import axios from 'axios';

const token = localStorage.getItem('accessToken');

axios.defaults.headers.common = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
axios.defaults.baseURL = process.env.REACT_APP_API_ROOT;

const apiClient = axios.create();

const Api = async ({
  method = 'get',
  endpoint = '',
  body,
  headers = {},
  onError = err => Promise.reject(err),
  onUnauthorized = () => { }
}) => {
  try {
    const request = await apiClient[method.toLowerCase()](endpoint, body, { headers });
    const response = request.data;

    return response;

  } catch ({ response: { data, status, statusText } }) {

    return onError({ data, status, statusText })
  }
}

export default Api;